module.exports = __webpack_public_path__ + "static/img/alf.3f796a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alf.jpg
// module id = rrRh
// module chunks = 1